import { upmPluginAOP } from './upm';
import { microAppPluginAOP } from './microApp';
import { lcdpluginAOP } from './lcdp';
import { axiosPluginAOP } from './axios';
import { microPluginAOP } from './micro';
import { IframeExtension, iframeAccessPluginAOP } from './iframe';
import { radarPluginAOP } from './radar';
import { logger } from '../logger';

import type { LcdpExtension } from '../../kastjs/lcdp';
import type { InnerOptions, KContext } from '../types';

export type PluginMap = typeof pluginsMap;
export type PluginName = keyof PluginMap;
export type PluginOption<K extends PluginName> = Parameters<PluginMap[K]>[1];
export type Plugins = {
  [K in PluginName]?: Partial<PluginOption<K>> | boolean;
};
export type CRMExtension = LcdpExtension & IframeExtension;

export const pluginsMap = {
  /** upm插件 */
  upm: upmPluginAOP,
  /** dolly插件 */
  microApp: microAppPluginAOP,
  /** lcdp插件 */
  lcdp: lcdpluginAOP,
  /** 微前端插件 */
  micro: microPluginAOP,
  /** iframe */
  iframe: iframeAccessPluginAOP,
  /** axios */
  axios: axiosPluginAOP,
  /** 雷达插件 */
  radar: radarPluginAOP,
};

export async function resolve(context: KContext, options: InnerOptions) {
  /** 插件执行顺序 */
  const plugins: Array<PluginName> = ['radar', 'upm', 'lcdp', 'microApp', 'micro', 'iframe'];

  while (plugins.length > 0) {
    const pluginName = plugins.shift();

    /**
     * 插件不启用
     * 显示声明插件才执行
     */
    if (!pluginName || !options[pluginName]) continue;

    try {
      /** 执行插件 */
      const params = await pluginsMap[pluginName]?.(context, options[pluginName] || {}, options);

      /** 记录日志 */
      logger.push(`执行【${pluginName}】插件`, params);
    } catch (error) {
      console.warn(`执行${pluginName}插件失败：`, error);
    }
  }
}
